export default {
  title: 'The FightCamp package',
  pathId: 'fightcamp',
  description: 'Our most basic package includes just what you need to experience FightCamp. Track your progress, compete against others, and access our complete library of on-demand workouts.',
  shortDescription: 'Just What You Need to Experience FightCamp',
  testShopifyId: 'gid://shopify/Product/7820642484313',
  prodShopifyId: 'gid://shopify/Product/8701900620012',
  isSoldOut: false,
  primaryImg: {
    src: 'https://a.storyblok.com/f/152150/2000x1053/4d9082f6e7/fc-001-website-v2-shop-test-image.png',
    alt: 'Console with trackers',
  },
  includes: [
    {
      productName: 'Free-Standing Boxing Bag',
      pathId: 'fightcamp-boxing-bag',
      description: 'Recognized as the best bag on the market, the FightCamp Free-Standing Boxing Bag combines sleek design with unmatched durability. It holds about 250 lbs of water or 350 lbs of sand (use sand for extra stability) and is paired with the FightCamp Bag ring to ensure the bag stays firmly in place during your most intense workouts.',
      shortDescription: 'The FightCamp Free-Standing Boxing Bag is the best free-standing bag on the market.',
      isSoldOut: false,
      primaryImg: {
        src: 'https://a.storyblok.com/f/152150/1648x1648/ea6b30a5cc/fc-freestanding-bag-ring.jpg',
        alt: 'Boxing bag and ring',
      },
      lifestyleImage: {},
      includesModalCopy: {},
      assets: [],
      features: [
        {
          title: 'Features',
          copy: [
            'Free-standing heavy bag with secure base and top construction',
            'High-density foam interior with durable vinyl cover',
            'Hook-and-loop tension belts secure top to base',
            'Bag ring prevents sliding and protects flooring',
            'Includes 4 bumpers for added stability',
            'Easy to install and reposition with tilt-and-roll design',
          ],
        },
        {
          title: 'Size & Fit',
          copy: [
            'Bag height: 67" when fully assembled',
            'Bag Top diameter: 18". Bag Base diameter: 24"',
            'Bag ring diameter: 24" circular mat',
            'Unfilled base weight: base 13 lbs, top 17 lbs',
            'Filled base weight: up to 250 lbs with water or 350 lbs with sand',
          ],
        },
        {
          title: 'Materials & Care',
          copy: [
            'Bag: High-density foam interior, vinyl exterior',
            'Bag ring: Made of heavy-duty plastics and rubber',
            'Wipe clean with a damp cloth; store indoors when not in use',
          ],
        },
      ],
    },
    {
      productName: 'Boxing Gloves',
      pathId: 'fightcamp-gloves',
      description: 'Made from premium genuine leather for lasting durability and wrist support. Hand-crafted with extra padding for impact protection and added weight to build strength. Built for serious training — better than vinyl and made to last.',
      shortDescription: 'Boxing Gloves',
      isSoldOut: false,
      primaryImg: {
        src: 'https://a.storyblok.com/f/152150/400x362/d48f334ba2/fc-boxing-gloves-lifestyle-001.png',
        alt: 'White FightCamp boxing gloves',
      },
      lifestyleImage: {},
      includesModalCopy: {},
      assets: [],
      features: [
        {
          title: 'Features',
          copy: [
            'Ventilated palms for breathability',
            'Hook and loop wrist enclosure',
            'Multi-layered foam padding',
            'FightCamp logo on cuff',
          ],
        },
        {
          title: 'Size & Fit',
          copy: [
            'Available in 12oz, 16oz (oz refers to weight of padding in the glove)',
            'Less than 5’9” / 170lb+ typically use 12oz (also great for speed of combinations)',
            'Above 5’9” / 170lb typically use 16oz (builds shoulder strength over time)',
            'Ergonic fit',
            'Also available in Kids Size typically for Age 12 and under',
          ],
        },
        {
          title: 'Materials & Care',
          copy: [
            'Made from premium leather',
            'Wipe clean with damp cloth; do not machine wash',
          ],
        },
      ],

    },
    {
      productName: 'Console + 4 Trackers',
      description: 'Your training experience will be elevated with real-time performance data. The FightCamp Console stores and charges your 4 trackers, which slide into your quick wraps to unlock the full interactive experience. Every punch and kick is measured for speed, volume, and intensity — so you can track progress, push harder, and compete against your personal best.',
      shortDescription: 'Heart of FightCamp',
      isSoldOut: false,
      primaryImg: {
        src: 'https://a.storyblok.com/f/152150/352x352/213b19df90/fc-console-four-trackers-lifestyle-001.png',
        alt: 'FightCamp console with trackers',
      },
      lifestyleImage: {},
      includesModalCopy: {},
      assets: [],
      features: [
        {
          title: 'Features',
          copy: [
            'Console: Keeps trackers powered and organized',
            'HDMI Plug-and-Play Setup: Connects directly to your TV',
            'LED Lighting: Adds visual feedback',
            'Sleek, Compact, and Modern design to complement your home gym',
            '4 punch / kick trackers',
          ],
        },
        {
          title: 'Size & Fit',
          copy: [
            'Dimensions: 7.9” x 3.9” x 1.3”',
            'Console can be mounted on wall or sit on shelf',
          ],
        },
      ],
    },
    {
      productName: 'Quick Wraps',
      pathId: 'fightcamp-quick-wraps',
      description: 'These wraps secure your Trackers, add knuckle padding, and support your wrists — all in one sleek, sweat-wicking design. ',
      shortDescription: 'Wrap. Track. Protect.',
      isSoldOut: false,
      primaryImg: {
        src: 'https://a.storyblok.com/f/152150/352x352/5bc6c1c45e/fc-quickwraps-thumbnail-001.png',
        alt: 'FightCamp quick wraps',
      },
      lifestyleImage: {},
      includesModalCopy: {},
      assets: [],
      features: [
        {
          title: 'Features',
          copy: [
            'Secure pocket for punch trackers',
            'Wrist wrap with velcro attachment',
            'Padding on knuckles',
          ],
        },
        {
          title: 'Size & Fit',
          copy: [
            'Available in S/M and L/XL',
            "L/XL is typically best for individuals taller than 5'9",
            'Stretchable fabric ensures a snug, adaptive fit',
          ],
        },
        {
          title: 'Materials & Care',
          copy: [
            'Made from 80% polyester, 20% spandex',
            'Machine washable (cold wash) and tumble dry low',
          ],
        },
      ],
    },
    {
      productName: 'Ankle Wraps',
      pathId: 'fightcamp-ankle-wraps',
      description: 'Designed for kickboxing, the ankle wraps provide joint support while securing your Trackers. Features a discreet pocket near the ankle to keep your trackers stable and secure through every strike and combination.',
      shortDescription: 'Ankle Wraps',
      isSoldOut: false,
      primaryImg: {
        src: 'https://a.storyblok.com/f/152150/500x500/2720267f44/500x500_ankle.jpg',
        alt: 'FightCamp Ankle Wraps for kickboxing',
      },
      lifestyleImage: {},
      includesModalCopy: {},
      assets: [],
      features: [
        {
          title: 'Features',
          copy: [
            'Secure pocket for kick trackers',
            'Easy to put on and stays in place throughout training',
            'Supports ankle joints during kickboxing workouts',
          ],
        },
        {
          title: 'Size & Fit',
          copy: [
            'Available in two sizes: S/M and L/XL',
            'Stretchable fabric ensures a snug, adaptive fit',
          ],
        },
        {
          title: 'Materials & Care',
          copy: [
            'Made from 80% polyester, 20% spandex',
            'Machine washable (cold wash) and tumble dry low',
          ],
        },
      ],

    },
    {
      productName: 'Heart Rate Monitor',
      pathId: 'fightcamp-heart-rate-monitor',
      description: 'Heart Rate Monitor that syncs with the FightCamp app for live heart rate tracking. Sweat-resistant, low-profile, high performance.',
      shortDescription: 'Heart Rate Monitor',
      isSoldOut: false,
      primaryImg: {
        src: 'https://a.storyblok.com/f/152150/352x352/42889a5470/fc-heart-rate-monitor-person-001.png',
        alt: 'FightCamp quick wraps',
      },
      lifestyleImage: {},
      includesModalCopy: {},
      assets: [],
      features: [
        {
          title: 'Features',
          copy: [
            'Heart Rate tracking during workout',
            'Integrates with the FightCamp app',
            'Detachable monitor, from strap',
            'Operates on a replaceable coin battery with a life expectancy of 8-12 months - no charger needed',
          ],
        },
        {
          title: 'Size & Fit',
          copy: [
            'Adjustable elastic strap fits chest sizes 26” - 38”',
            'Soft, durable, and flexible chest strap for a secure and comfortable fit',
          ],
        },
        {
          title: 'Materials & Care',
          copy: [
            'Made with moisture resistant nylon and spandex fabric',
            'Wipe strap with soft damp cloth after use',
          ],
        },
      ],

    },
  ],
  includesBag: true,
  assets: [
    {
      src: 'https://a.storyblok.com/f/152150/1000x1000/9a207558e9/fc-living-room.jpg',
      alt: 'FightCamp Package',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1000x1000/bc0d46e6ff/fc-punch.jpg',
      alt: 'FightCamp user punching free standing bag',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1000x1000/95f35dd971/fc-partner-workout.jpg',
      alt: 'FightCamp partner workout',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1001x1000/2085a1b94c/fc-product-carousel-4.jpg',
      alt: 'FightCamp quick wraps with trackers',
    },
    {
      src: 'https://a.storyblok.com/f/152150/1001x1000/a5b659c1ff/fc-product-carousel-5.jpg',
      alt: 'Person working out with FightCamp',
    },
  ],
};
